exports = module.exports = require("../../../../../../../usr/lib/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".besidaMob-icon__root--3SZdl{display:block;fill:currentColor;height:100%;vertical-align:middle;width:100%}", ""]);

// exports
exports.locals = {
	"root": "besidaMob-icon__root--3SZdl"
};